import React from "react";
import "./Titre.css";

function Titre() {
  return (
    <div className="Titre">
      
      <h1>A propos</h1>
    </div>
  );
}

export default Titre;
